import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { IClaim } from '../../shared/interfaces/claim.interface';

@Injectable({
  providedIn: 'root',
})
export class ClaimsService {
  constructor(private readonly http: HttpClient) {}

  getClaims(): Observable<string[]> {
    return this.http
      .get<IClaim[]>('claims')
      .pipe(map((claims: IClaim[]) => (claims ?? []).map((claim) => claim.Value)));
  }
}
